/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ResponseSatisfactionSurveyData = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        surveyId: {
    type: 'number',
    isRequired: true,
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        question: {
    type: 'string',
    isRequired: true,
},
        resident: {
    type: 'string',
    isRequired: true,
},
        comment: {
    type: 'string',
    isRequired: true,
},
        meet: {
    type: 'boolean',
    isRequired: true,
},
        skipQuestion: {
    type: 'boolean',
    isRequired: true,
},
    },
};